import { render, staticRenderFns } from "./page-spinner.vue?vue&type=template&id=bbe2cf82&"
import script from "./page-spinner.vue?vue&type=script&lang=js&"
export * from "./page-spinner.vue?vue&type=script&lang=js&"
import style0 from "./page-spinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports